import {useMutation} from "@tanstack/react-query";

import {updateServiceMutationOptions} from "./update-service.mutation-options";

export function useUpdateService(id: string) {
  return useMutation(updateServiceMutationOptions(id));
}
